export const getRowItemId = (row: any, index: number): string => {
	return row?.id?.toString() || `row-${index}`;
};
